import React from 'react';
import '../less/leasing.less';
import hero_img from '../img/hero_img.svg';
import Hero from '../../../../../../../auxiliary-components/shared/HeroBlock';
import BusinessOrder from '../../../../../../BusinessOrder';
import hero_data from '../enums/hero_data.json';
import { govLeasingConditionsLink } from '../../../../../../../services/urls/urls';
import serviceUsageItems from '../enums/service_usage_items.json';
import InfoBlock from './../../../../../../../auxiliary-components/shared/InfoBlock';
import { getSafeLinkProps } from '../../../../../../../helpers/utils/urlSecurity';

export default function template() {
    const page = 'gov-leasing';
      
    const handlersMap = {
      toggleHeroModal: () => this.toggleModal(),
    };

    const heroData = {
      ...hero_data,
      link: {
        ...hero_data.link,
        onClick: handlersMap[hero_data.link.onClick],
      },
    };

    return (
      <div className="module-gov-leasing">
        <Hero
          data={heroData}
          img={hero_img}
          svg
          className="gov-programs"
        />
        <div className="content">
          <div className="general-info">
            <div className="container">
              <div className="general-info__body">
                <div className="general-info__text">{this.l10n('BUSINESS_GOV_LEASING_GENERAL_INFO_TEXT')}</div>
                <InfoBlock text={'BUSINESS_GOV_LEASING_INFO_INFO_TEXT_01'}/>
                <InfoBlock text={`BUSINESS_GOV_LEASING_INFO_INFO_TEXT_02`}/>
                <a className="general-info__btn" {...getSafeLinkProps(govLeasingConditionsLink)}>
                  {this.l10n('BUSINESS_GOV_LEASING_GENERAL_INFO_BTN')}
                </a>
              </div>
            </div>
          </div>
          <div className="service-usage">
            <div className="container">
              <h2 className="service-usage__title">{this.l10n('BUSINESS_GOV_LEASING_SERVICE_USAGE_TITLE')}</h2>
              <div className="service-usage__body">
                {serviceUsageItems.map((item, index) => (
                  <div key={index} className="service-usage__item item-service-usage">
                    <div className="item-service-usage__title">{this.l10n(item.title)}</div>
                    <div className="item-service-usage__text">
                      {item.text && this.l10n(item.text)}
                      {item.link && (
                        <a {...getSafeLinkProps(govLeasingConditionsLink)}>{this.l10n(item.link)}</a>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
        {this.state.showModal && <BusinessOrder attribute="leasing" closeModal={this.toggleModal} />}
      </div>
    );
}
